import React from 'react';

const SelectBox = function({title,children,...props}) {

    return (
        <div className="input-container">
          <h3 className="input-container-text">{title}</h3>
            {children}
        </div>
    );
}

export default SelectBox;
